<template>
  <div class="ui-result-state" :class="`ui-result-state--${tone}`" role="status" aria-live="polite">
    <span class="ui-result-state__icon" aria-hidden="true">
      <LoaderCircle v-if="tone === 'loading'" class="ui-spin" :size="30" :stroke-width="2.4" />

      <component :is="icon" v-else :size="30" :stroke-width="2" />
    </span>

    <h2 class="ui-result-state__title">{{ title }}</h2>

    <p v-if="text" class="ui-result-state__text">{{ text }}</p>

    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { LoaderCircle } from "lucide-vue-next";

withDefaults(
  defineProps<{
    title: string;
    text?: string;
    icon?: Component;
    tone?: "success" | "danger" | "info" | "loading";
  }>(),
  {
    text: undefined,
    icon: undefined,
    tone: "info",
  },
);
</script>
